import React from 'react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  quote: 'Leer sobre menopausia desde este lugar me hizo sentir acompañada por primera vez. No es un libro médico, es un abrazo con información.',
  author: 'Marcela',
  age: '52 años'
}, {
  quote: 'El ebook sobre depresión me ayudó a poner en palabras lo que sentía. No me dio soluciones mágicas, pero me hizo sentir menos sola.',
  author: 'Valentina',
  age: '34 años'
}, {
  quote: 'Nunca nadie me había hablado así sobre mi cuerpo. Con respeto, con información y sin juzgar.',
  author: 'Camila',
  age: '28 años'
}, {
  quote: 'Compré el de autoestima y cuerpo pensando que ya sabía todo. Me sorprendió lo mucho que necesitaba leerlo.',
  author: 'Lucía',
  age: '41 años'
}];
export function Testimonials() {
  return <section className="py-24 md:py-32 bg-crema" data-id="element-178">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-179">
        <FadeIn className="text-center mb-16" data-id="element-180">
          <h2 className="font-serif text-4xl md:text-5xl text-texto mb-6" data-id="element-181">
            Lecturas que acompañan
          </h2>
          <p className="font-sans text-lg text-textoSuave max-w-2xl mx-auto" data-id="element-182">
            Voces de mujeres reales que encontraron en nuestras páginas un
            espacio seguro para entenderse.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-183">
          {testimonials.map((test, index) => <FadeIn key={index} delay={index * 0.1} className="bg-blanco p-8 md:p-10 rounded-3xl shadow-soft relative" data-id="element-184">
              <div className="absolute top-8 left-8 text-6xl font-serif text-rosa/40 leading-none" data-id="element-185">
                "
              </div>
              <div className="relative z-10 pl-6" data-id="element-186">
                <p className="font-sans text-lg md:text-xl text-texto leading-relaxed mb-6 italic" data-id="element-187">
                  {test.quote}
                </p>
                <div className="flex items-center gap-3" data-id="element-188">
                  <div className="w-10 h-10 rounded-full bg-durazno flex items-center justify-center font-serif text-texto text-xl" data-id="element-189">
                    {test.author.charAt(0)}
                  </div>
                  <div data-id="element-190">
                    <p className="font-sans font-bold text-texto" data-id="element-191">
                      {test.author}
                    </p>
                    <p className="font-sans text-sm text-textoSuave" data-id="element-192">
                      {test.age}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}